import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragment;
}

const ActivityLogTaskFlagResolvedCandidateDeclined: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.resolvedFlag"
    />
  );
};

ActivityLogTaskFlagResolvedCandidateDeclined.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskFlagResolvedCandidateDeclined_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskFlagResolvedCandidateDeclined;
